// Blog-specific GA4 events. `track` is imported from ./analytics rather than
// redeclared here: this file kept its own three-line copy, so it never passed
// through the reserved-param filter and `source: 'blog'` rewrote the traffic
// source of every session that read a blog post. One filter, not two.
import { track } from './analytics'

/** Track when a visitor views a blog post */
export function trackBlogView(slug: string, category: string) {
  track('blog_view', {
    event_category: 'content',
    blog_slug: slug,
    blog_category: category,
    event_source: 'blog',
  })
}
